'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isUnlockedRequirement = function isUnlockedRequirement(requirement) {
    return (
        // we don't a requirement as locked if it is editable, or an OFFLINE requirement,
        // or a requirement which is being viewed by another customer for an exempted requirement
        requirement.editable || requirement.flags.includes('OFFLINE')
    );
};

// hidePrompt: We don't want to show a locked field prompt if the user viewing the form is being
//             presented with a prompt like "this must be completed by user X, send them a reminder"
var FormLockedField = function FormLockedField(_ref) {
    var requirementsByCode = _ref.requirementsByCode,
        _ref$hidePrompt = _ref.hidePrompt,
        hidePrompt = _ref$hidePrompt === undefined ? false : _ref$hidePrompt;

    var hasLocked = !hidePrompt && !(0, _keys2.default)(requirementsByCode).every(function (reqCode) {
        var requirement = requirementsByCode[reqCode];
        if (_lodash2.default.isArray(requirement)) {
            // For requirements like ARRIVAL_FLIGHT_DETAILS which we store as arrays
            return requirement.every(function (req) {
                return isUnlockedRequirement(req);
            });
        } else {
            return isUnlockedRequirement(requirement);
        }
    });

    return hasLocked ? _react2.default.createElement(_components2.FormInstructionalText, {
        instructionalText: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formLockedField.prompt',
            defaultMessage: 'If a locked field needs to be updated, please {contactUs}.',
            values: { contactUs: _react2.default.createElement(_components2.DynamicCommunication, { type: 'contactPrompt' }) } }) }) : null;
};

exports.default = FormLockedField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/FormLockedField.js
// module id = 1343
// module chunks = 0